import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/cruiseAdditionalOptions', request)
}

export {get}
